import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { useChannel } from '../../hooks/useChannel';
import { useAuth } from '../../hooks/useAuth';
import toast from 'react-hot-toast';

interface Props {
  onClose: () => void;
}

export const WooCommerceModal: React.FC<Props> = ({ onClose }) => {
  const [formData, setFormData] = useState({
    storeName: '',
    storeUrl: '',
    consumerKey: '',
    consumerSecret: '',
    weightUnit: 'KG',
    currency: 'INR',
    dimensionUnit: 'CM',
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const { integrateWooCommerceAsync, isIntegrating } = useChannel();
  const { user } = useAuth();

  const handleConfirm = async () => {
    if (
      !formData.storeName ||
      !formData.storeUrl ||
      !formData.consumerKey ||
      !formData.consumerSecret
    ) {
      toast.error('Please fill all required fields');
      return;
    }

    let url = formData.storeUrl;
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }

    try {
      const response = await integrateWooCommerceAsync({
        store_name: formData.storeName,
        store_url: url,
        consumer_key: formData.consumerKey,
        consumer_secret: formData.consumerSecret,
        user_id: Number(user?.id),
      });

      if (response?.status) {
        toast.success(
          response.message || 'WooCommerce settings saved successfully'
        );
        onClose();
      } else {
        toast.error(response?.message || 'Failed to integrate WooCommerce');
      }
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          'Failed to integrate WooCommerce'
      );
    }
  };

  return (
    <div className="flex flex-col w-full">
      <div className="text-center mb-6 pt-2">
        <h2 className="text-2xl font-semibold text-gray-800">
          Integrate Woocommerce Store
        </h2>
        <a
          href="#"
          className="text-[#4A90E2] font-medium text-sm mt-3 inline-block hover:underline"
        >
          How to get Keys? Click here know.
        </a>
      </div>

      <div className="space-y-4 px-2">
        <Input
          label="Store Name *"
          name="storeName"
          value={formData.storeName}
          onChange={handleChange}
          required
        />

        <Input
          label="Store URL (https://www.example.com) *"
          name="storeUrl"
          value={formData.storeUrl}
          onChange={handleChange}
          required
        />

        <Input
          label="Consumer Key (ck_XXXXXXXXX....) *"
          name="consumerKey"
          value={formData.consumerKey}
          onChange={handleChange}
          required
        />

        <Input
          label="Consumer Secret (cs_XXXXXXXXX.....) *"
          name="consumerSecret"
          value={formData.consumerSecret}
          onChange={handleChange}
          required
        />
      </div>

      <div className="flex justify-end gap-4 mt-10 pr-2">
        <Button
          variant="outline"
          onClick={onClose}
          className="font-semibold"
          disabled={isIntegrating}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          className="font-semibold"
          variant="default"
          disabled={isIntegrating}
        >
          {isIntegrating ? 'Integrating...' : 'Confirm'}
        </Button>
      </div>
    </div>
  );
};
